import { render, staticRenderFns } from "./AddCostRevenue.vue?vue&type=template&id=86c5dfe6&scoped=true"
import script from "./AddCostRevenue.vue?vue&type=script&lang=js"
export * from "./AddCostRevenue.vue?vue&type=script&lang=js"
import style0 from "./AddCostRevenue.vue?vue&type=style&index=0&id=86c5dfe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c5dfe6",
  null
  
)

export default component.exports